import { Modal } from 'react-bootstrap';
import ActivatedIcon from 'assets/img/verification/verified.svg';
import Button from 'components/base/Button';

interface Props {
  show: boolean;
  handleSubmit: () => void;
}

const AccountActivatedModal = ({ show, handleSubmit }: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered>
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={ActivatedIcon} width={150} />
        </div>
        <h5 className="text-center fs-6">Account Activated</h5>
        <p className="mt-3 text-center">
          Your account has been activated. Please proceed to sign in and enjoy
          access to all our services. If you encounter any issues, feel free to
          contact support for assistance.
        </p>
        <div className="d-flex justify-content-center mb-2">
          <Button variant="outline-primary" onClick={handleSubmit}>
            Back to sign in
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AccountActivatedModal;
